<app-content-body [isCentralized]='true' height="90vh">

  <div class="container-sm" *ngIf="this.showForm">

    <div class="row justify-content-center py-5">

      <div class="col-md-5 border rounded shadow-sm p-4">

        <img class="img-fluid mb-4 logoheight" src="https://www.alachisoft.com/images/logo-d.svg" alt="NCache" />

        <form [formGroup]="this.resetPasswordFormGroup" (ngSubmit)="onResetFormSubmission()">

          <div class="row mb-3">
            <div>
              <label class="form-label" for="email">{{ this.email }}</label>
            </div>
          </div>

          <div class="mb-4">

            <h2 class="mb-4">Reset Password</h2>

            <div class="mb-3" *ngIf="this.showCurrentPassword">
              <label for="current_password" class="form-label">Current Password</label>

              <div class="input-group">
                <input
                  tabindex="0"
                  [type]="passwordShow ? 'text' : 'password'"
                  formControlName="current_password"
                  class="form-control"
                  placeholder="Enter Current Password"
                  minlength="8"
                  [ngClass]="{ 'is-invalid': this.resetFormSubmitted && this.resetPassswordForm.current_password.errors }"
                />

                <button
                  tabindex="-1"
                  type="button"
                  (click)="onPasswordShowClick('passwordShow')"
                  class="btn btn-outline-secondary border-start-0">
                  <i class="fa" [ngClass]="passwordShow ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true"></i>
                </button>

                <div *ngIf="this.resetFormSubmitted && this.resetPassswordForm.current_password.errors" class="invalid-feedback">
                  <div *ngIf="this.resetPassswordForm.current_password.errors.required">Current password is required</div>
                </div>

              </div>

            </div>

            <div class="mb-3">

              <label for="password" class="form-label">New Password</label>

              <div class="input-group">
                <input
                  tabindex="0"
                  [type]="newPasswordShow ? 'text' : 'password'"
                  formControlName="password"
                  class="form-control"
                  placeholder="Enter New Password"
                  minlength="8"
                  [ngClass]="{ 'is-invalid': this.resetFormSubmitted && this.resetPassswordForm.password.errors }"
                />

                <button tabindex="-1" type="button" (click)="onNewPasswordShowClick('newPasswordShow')" class="btn btn-outline-secondary border-start-0" >
                  <i class="fa" [ngClass]="newPasswordShow ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true"></i>
                </button>

                <div *ngIf="this.resetFormSubmitted && this.resetPassswordForm.password.invalid" class="invalid-feedback">
                  <div *ngIf="this.resetPassswordForm.password.errors.required">New Password is required</div>
                  <div *ngIf="this.resetPassswordForm.password.errors?.minlength">Password must be at least 8 characters</div>
                  <div *ngIf="this.resetPassswordForm.password.errors?.maxlength">Password must be maximum 100 characters</div>
                  <div *ngIf="this.resetPassswordForm.password.errors?.pattern">Password must contain uppercase, lowercase, and a number</div>
                  <div *ngIf="this.resetPassswordForm.password.errors?.uniqueValidator">Password cannot be the same as the old password</div>
                </div>

              </div>
            </div>

            <div class="mb-3">
              <label for="confirm_password" class="form-label">Confirm Password</label>
              <div class="input-group">
                <input
                  tabindex="0"
                  [type]="confirmPasswordShow ? 'text' : 'password'"
                  formControlName="confirm_password"
                  class="form-control"
                  placeholder="Confirm New Password"
                  [ngClass]="{ 'is-invalid': this.resetFormSubmitted && this.resetPassswordForm.confirm_password.errors }"
                />
                <button
                  type="button"
                  tabindex="-1"
                  (click)="onConfirmPasswordShowClick('confirmPasswordShow')"
                  class="btn btn-outline-secondary border-start-0"
                >
                  <i class="fa" [ngClass]="confirmPasswordShow ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true"></i>
                </button>
                <div *ngIf="this.resetFormSubmitted && this.resetPassswordForm.confirm_password.invalid" class="invalid-feedback">
                  <div *ngIf="this.resetPassswordForm.confirm_password.errors.required">Password confirmation is required</div>
                  <div *ngIf="this.resetPassswordForm.confirm_password.errors.confirmedValidator">Passwords do not match</div>
                </div>
              </div>
            </div>
          </div>

          <a (click)="this.navigateToLogin($event)" class="btn btn-link px-0">Go Back</a>

          <button [disabled]="isSubmittingResetForm" class="btn btn-primary float-end">
            <span *ngIf="isSubmittingResetForm" class="spinner-border spinner-border-sm me-2"></span>
            <span *ngIf="isResetPasswordAction()">Reset</span>
            <span *ngIf="isUpdatePasswordAction()">Update Password</span>
          </button>

        </form>

      </div>
    </div>
  </div>

</app-content-body>
